import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'

import { Spinner } from 'library'
// import { IS_BROWSER } from 'src/localConstants'

const PrivatePage = ({
  children,
  canAccess,
  isAuthLoading,
  loginRoute,
  location,
}) => {
  const redirectPath = location ? `&redirectTo=${location.pathname}` : ''

  useEffect(() => {
    if (!isAuthLoading && !canAccess && location.pathname !== loginRoute) {
      navigate(loginRoute + redirectPath)
    }
  }, [isAuthLoading, canAccess, location.pathname, loginRoute, redirectPath])

  return (
    <>
      {isAuthLoading && !canAccess && (
        <div style={{ height: '100vh' }}>
          <Spinner size={3} isCenteredTop>
            Checking login status…
          </Spinner>
        </div>
      )}
      {!isAuthLoading && canAccess && children}
    </>
  )
}

PrivatePage.propTypes = {
  canAccess: PropTypes.bool.isRequired,
  loginRoute: PropTypes.string.isRequired,
}

export default PrivatePage
